import PriceTotal from 'components/ProductPage/PdpBundling/BundleWidget/PriceTotal/PriceTotal';

export default PriceTotal;
